export default __webpack_public_path__ + "static/totem-mobile-242b4cca3bd6fe76fd930d85fe31f19d.jpg";